// extracted by mini-css-extract-plugin
export default {"wrapper":"Piyk6P6dS0vn8S5XEbVP","title":"rfiTYuzw4Q4z9SMbJOdy","item":"NiUP4xLMQkUC3saHXuqU","itemTitle":"ZQbHkbNAxhBqzxwdue83"};